import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

export enum WorkingStudentDegreeType {
  BACHELOR = 'Bachelor',
  MASTER = 'Master',
  STAATSEXAMEN = 'Staatsexamen',
}

@Entity()
export class ANWorkingStudent extends AdornisEntity {
  static override _class = 'ANWorkingStudent';

  @Field(() => Boolean, { default: v => v ?? false })
  workingStudent: Maybe<boolean>;

  @Field(() => String)
  degreeType: Maybe<WorkingStudentDegreeType>;

  @Field(() => Float, { default: v => v ?? 1 })
  partTimeStudentPercentage: Maybe<number>;

  @Field(() => Float, { default: v => v ?? 0 })
  hoursInOtherContracts: Maybe<number>;
}
